import SpriteSymbol from "../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Star",
  "use": "Star-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"Star\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8516 5.79293L10.4001 0L8.05161 5.59752H0.800049L6.56005 9.41176L4.64005 16L10.4001 12.2353L16.1601 16L14.2401 9.41176L20.0001 5.59752L12.8516 5.79293Z\" fill=\"#EBEBEB\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol